import { render, staticRenderFns } from "./TheMessages.vue?vue&type=template&id=77d1ce52&scoped=true&"
import script from "./TheMessages.vue?vue&type=script&lang=js&"
export * from "./TheMessages.vue?vue&type=script&lang=js&"
import style0 from "./TheMessages.vue?vue&type=style&index=0&id=77d1ce52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1ce52",
  null
  
)

export default component.exports